const deliveryBtnTxt = "डिलीवरी मार्क करे ";
const cxrtoBtnTxt = "आर्डर का रिटर्न लगाएं ";

export { deliveryBtnTxt, cxrtoBtnTxt };
